// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3ROvJ","list":"PatternAutocomplete_list__2SlWL"};